import currency from './currency';
import datetime from './datetime';


export default {
     install(Vue) {
         Vue.filter('currency', currency);
         Vue.filter('dt-time', datetime);
     }
}